<template>
    <div class="form-group">
        <base-input :error="error">
            <select
                v-model="department"
                v-validate="'required'"
                name="department"
                id="department"
                class="form-control"
            >
                <option :value="null" selected disabled>{{ $t('support.tickets.department') }}</option>
                <option
                    v-for="department in departments"
                    :key="department.id"
                    :value="department.id"
                >{{ department.translation.name }}</option>
            </select>
        </base-input>
    </div>
</template>

<script>
import BaseInput from "../../argon/components/Inputs/BaseInput";

export default {
    name: "SupportDepartmentsSelect",

    components: {
        BaseInput
    },

    props: {
        items: {
            type: Array,
            default: () => []
        },
        value: {
            type: Number,
            required: false
        },
        error: String
    },

    data() {
        return {
            departments: this.items
        };
    },

    mounted() {
        if (!this.items.length) {
            this.getDepartments();
        }
    },

    computed: {
        department: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },

    methods: {
        getDepartments() {
            this.$loading.show();
            return window.axios
                .get("/api/app/deparments/list")
                .then(res => {
                    this.departments = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                    this.$notify({
                        type: "danger",
                        message: err.response.data.error
                    });
                })
                .finally(() => {
                    this.$loading.close();
                });
        }
    }
};
</script>
